import styled, { css } from "styled-components";
import { deviceMax } from "../../../utils/device";

interface IEyebrow {
  /** Use on the dark navy panels, where the label switches to cyan. */
  light?: boolean;
}

export const Eyebrow = styled.p<IEyebrow>(
  ({ theme, light }) => css`
    color: ${light ? theme.colors.brand.cyan : theme.colors.brand.navy};
    font-size: 11px;
    font-weight: ${theme.typography.weights.bold};
    letter-spacing: 0.16em;
    line-height: 1.5;
    margin: 0 0 20px;
    text-transform: uppercase;

    @media ${deviceMax.tabletWideMax} {
      font-size: 9px;
    }

    @media ${deviceMax.phoneMax} {
      font-size: 10px;
      margin-bottom: 17px;
    }
  `
);

export default Eyebrow;
